"use client";

import logo from "@/assets/logo.svg";
import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link, NavLink } from "react-router-dom";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import canadaFlag from "@/assets/countries/canada-logo.svg";
import americaFlag from "@/assets/countries/united-states-flag.svg";
// import ScheduleDemo from "@/features/onboarding/login/Schedule-demo";
// import GradientButton from "../ui/gradient-button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "@/store";
import { GiHamburgerMenu } from "react-icons/gi";
import { setUser, toggleQuestion, logoutUser } from "@/features/auth/UserSlice";
import {
  // createCustomerPortalSession,
  setSubscriptionDetails,
} from "@/features/plans-and-subscription/subscriptionSlice";
import { useLoading } from "@/contexts/LoadingContext";

export default function Header() {
  const scrollToSection =
    (id: string) => (e: React.MouseEvent<HTMLButtonElement>) => {
      e.preventDefault();
      console.log("scrollToSection clicked 1 time");
      const element = document.getElementById(id);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
        console.log("scrolledToClickedSection 1 time");
      }
    };
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [selectedCountry, setSelectedCountry] = useState<"CA" | "US">("CA");
  const user = useSelector(
    (state: RootState) => state.rootReducer.userReducer.user
  );
  const [userName, setUserName] = useState<string|undefined>("");
  const dispatch = useDispatch<AppDispatch>();
  const { setLoading } = useLoading();
  // const subscriptionDetails = useSelector(
  //   (root: RootState) =>
  //     root.rootReducer.subscriptionReducer.subscriptionDetails
  // );

  useEffect(() => {
    // console.log("user", user);
    if (user) {
      const name = user.fullName as string ?? user.email?.split("@")[0];
      // console.log("name65", name);
      setUserName(name as string);
      // console.log("userName", name);
      dispatch(setUser(user));
    } else {
      const localUser = JSON.parse(localStorage.getItem("user") + "");
      if (localUser) {
        // console.log("local user", localUser);
        dispatch(setUser(localUser));
        if (localUser.subscription_details) {
          dispatch(setSubscriptionDetails(localUser.subscription_details));
        }
        const questionDone = localStorage.getItem("questionDone");
        if (questionDone) {
          dispatch(toggleQuestion(questionDone == "true"));
        }
      }
    }
  }, [user, dispatch]);

  const logout = () => {
    try {
      setLoading(true);
      dispatch(logoutUser()).then(() => {
        window.location.reload();
      });
    } finally {
      setLoading(false);
    }
  };

  // const setUpCustomerPortalSession = useCallback(async () => {
  //   setLoading(true);
  //   const res = await createCustomerPortalSession({
  //     returnUrl: "https://buildmapper.ai",
  //   });
  //   setLoading(false);
  //   if (res.statusCode == 200) {
  //     const session = res.data.customerPortalSession;
  //     if (session) {
  //       window.open(session.url, "_self");
  //     }
  //   }
  // }, [setLoading]);

  return (
    <header className="w-full border-b bg-white sticky top-0 z-50 ">
      <div className="mx-auto flex h-16 items-center justify-between lg:px-[5%] md:px-[1.5%] sm:px-[2%] px-[5%]">
        {/* Logo */}
        <NavLink to="/">
          <img src={logo} alt="company-logo" className="h-[40px]" />
        </NavLink>

        {/* Desktop Navigation */}
        <nav className="hidden md:flex items-center lg:gap-8 md:gap-0">
          <Button
            variant="ghost"
            onClick={scrollToSection("feature-section")}
            className="!bg-transparent xl:text-[16px] lg:text-[14px] text-[12px] font-medium text-charcoal hover:text-bmpGreen-500"
          >
            Features
          </Button>
          <Button
            variant="ghost"
            onClick={scrollToSection("how-it-works")}
            className="!bg-transparent xl:text-[16px] lg:text-[14px] text-[12px] font-medium text-charcoal hover:text-bmpGreen-500"
          >
            How it Works
          </Button>
          <Button
            variant="ghost"
            onClick={scrollToSection("testimonials")}
            className="!bg-transparent xl:text-[16px] lg:text-[14px] text-[12px] font-medium text-charcoal hover:text-bmpGreen-500"
          >
            Testimonials
          </Button>

          {/* {user !== null ? (
            <NavLink to='/dashboard/explore_leads'>
              <Button
                variant="ghost"
                className="!bg-transparent xl:text-[16px] lg:text-[14px] text-[12px] font-medium text-charcoal hover:text-bmpGreen-500"
              >
                Explore Leads
              </Button>
            </NavLink>
          ) : (
            <ScheduleDemo>
              <Button
                variant="ghost"
                className="!bg-transparent xl:text-[16px] lg:text-[14px] text-[12px] font-medium text-charcoal hover:text-bmpGreen-500"
              >
                Explore Leads
              </Button>
            </ScheduleDemo>
          )} */}
          {user !== null ? (
            <NavLink to="/dashboard/explore_leads">
              <Button
                variant="ghost"
                className="!bg-transparent xl:text-[16px] lg:text-[14px] text-[12px] font-medium text-charcoal hover:text-bmpGreen-500"
              >
                Explore Leads
              </Button>
            </NavLink>
          ) : (
            <Link to="/auth/signup" className="!no-underline">
            <Button
              variant="ghost"
              // onClick={() =>
              //   window.open(
              //     "https://buildmapper.typeform.com/to/oVrzJex7",
              //     "_blank"
              //   )
              // }
              className="!bg-transparent xl:text-[16px] lg:text-[14px] text-[12px] font-medium text-charcoal hover:text-bmpGreen-500"
            >
              Explore Leads
            </Button>
            </Link>

          )}
        </nav>

        {/* Desktop Actions */}
        <div className="hidden md:flex items-center gap-4">
          <NavLink to="/auth/login" aria-label="Login">
            <Select
              value={selectedCountry}
              onValueChange={(e) => {
                setSelectedCountry(e as typeof selectedCountry);
              }}
            >
              <SelectTrigger className="w-[80px] h-[40px] text-charcoal">
                <SelectValue placeholder="Country" />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="CA">
                  <img
                    src={canadaFlag}
                    alt="canada-flag"
                    width="32px"
                    height="32px"
                  />
                </SelectItem>
                <SelectItem value="US">
                  <img
                    src={americaFlag}
                    alt="usa-flag"
                    width="32px"
                    height="32px"
                  />
                </SelectItem>
              </SelectContent>
            </Select>
          </NavLink>

          {user ? (
            <DropdownMenu>
              <DropdownMenuTrigger asChild>
                <Button className="h-[40px]  cursor-pointer" variant="outline">
                  <div className="flex items-center gap-2">
                    {user.avatar_url ? (
                      // <div className="size-7 rounded-full">
                      <img
                        className="size-8 rounded-full object-cover"
                        src={user.avatar_url}

                        alt=""
                      // onError={(e) => {
                      //   const target = e.target as HTMLImageElement & { _fallbackTried?: boolean };

                      //   if (!target._fallbackTried) {
                      //     target._fallbackTried = true;
                      //     target.onerror = null; // prevent infinite loop
                      //     target.src = `data:image/svg;base64,${user.user_avatar}`; // retry without +xml
                      //   }
                      // }}
                      />
                      // </div>
                    ) : (
                      <div className="size-7 flex align-middle items-center justify-center rounded-full p-1 text-white uppercase !bg-charcoal">
                        {user.email ? user.email.substring(0, 2) : "-"}
                      </div>
                    )}
                    <span className="capitalize">{userName ? userName : "John Doe"}</span>
                    <GiHamburgerMenu className="text-[20px]" />
                  </div>
                </Button>
              </DropdownMenuTrigger>
              <DropdownMenuContent className="w-52">
                <DropdownMenuLabel className="text-charcoal cursor-pointer text-[16px]">
                  My Account
                </DropdownMenuLabel>
                <DropdownMenuSeparator />
                <Link to="/profile/user-profile">
                  <DropdownMenuItem className="text-charcoal cursor-pointer text-[16px]">

                    Settings
                  </DropdownMenuItem>
                </Link>
                {/* <DropdownMenuItem className="text-charcoal cursor-pointer text-[16px]">
                  My Leads
                </DropdownMenuItem> */}
                <DropdownMenuItem
                  onClick={logout}
                  className="text-charcoal cursor-pointer text-[16px]"
                >
                  Log out
                </DropdownMenuItem>
                {/* {subscriptionDetails && (
                  <>
                    <DropdownMenuSeparator />
                    <DropdownMenuLabel className="text-charcoal cursor-pointer text-[16px]">
                      Active Subscription
                    </DropdownMenuLabel>

                    <DropdownMenuItem
                      onClick={setUpCustomerPortalSession}
                      className="text-charcoal cursor-pointer text-[16px] flex justify-between"
                    >
                      <span className="text-primary">
                        {subscriptionDetails.odoo_subscription_name}
                      </span>
                      <span className="font-semibold">
                        ${" "}
                        {subscriptionDetails.amount > 1000
                          ? subscriptionDetails.amount / 1000 + "K"
                          : subscriptionDetails.amount}
                      </span>
                    </DropdownMenuItem>
                  </>
                )} */}
              </DropdownMenuContent>
            </DropdownMenu>
          ) : (
            <>
              <Link to="/auth/login" className="!no-underline">
                <Button className="font-medium bg-primary h-[40px] hover:bg-[#239e41] shadow-none text-white text-xs md:text-sm">
                  Sign In
                </Button>
              </Link>
              {/* <Link to="/auth/signup" className="!no-underline">
                <Button className="font-medium bg-primary h-[40px] hover:bg-[#239e41] shadow-none text-white text-xs md:text-sm">
                  Sign Up
                </Button>
              </Link> */}

              {/* <a
                href={`${window.location.origin}/newOnboarding`}
                target="_self"
                rel="noopener noreferrer"
              > */}
              <Link to="/auth/signup" className="!no-underline">
                <Button className="w-[120px] md:w-[140px] h-8 md:h-10 rounded-md bg-primary hover:bg-[#239e41] shadow-none text-xs md:text-sm font-medium text-white">
                  Get Started
                </Button>
                </Link>
              {/* </a> */}
            </>
          )}
        </div>

        {/* Mobile Menu Button */}
        <button
          className="md:hidden"
          onClick={() => setIsMenuOpen(!isMenuOpen)}
        >
          {isMenuOpen ? (
            <X className="h-6 w-6" />
          ) : (
            <Menu className="h-6 w-6" />
          )}
        </button>
      </div>

      {/* Mobile Menu */}
      {isMenuOpen && (
        <div className="md:hidden border-t">
          <div className="container mx-auto px-4 py-4 flex flex-col gap-4">
            <Button
              onClick={(e) => {
                scrollToSection("how-it-works")(e);
                setIsMenuOpen((prev) => !prev);
              }}
              className="!bg-transparent text-[16px] font-medium text-charcoal hover:text-bmpGreen-500"
            >
              Features
            </Button>
            <Button
              // onClick={scrollToSection("how-it-works")}
              onClick={(e) => {
                scrollToSection("how-it-works")(e);
                setIsMenuOpen((prev) => !prev);
              }}
              className="!bg-transparent text-[16px] font-medium text-charcoal hover:text-bmpGreen-500"
            >
              How it Works
            </Button>
            <Button
              onClick={(e) => {
                scrollToSection("testimonials")(e);
                setIsMenuOpen((prev) => !prev);
              }}
              className="!bg-transparent text-[16px] font-medium text-charcoal hover:text-bmpGreen-500"
            >
              Testimonials
            </Button>
            <div className="flex items-center justify-center gap-4 pt-2">
              <NavLink to="/auth/login" aria-label="Login">
                <Select
                  value={selectedCountry}
                  onValueChange={(e) => {
                    setSelectedCountry(e as typeof selectedCountry);
                  }}
                >
                  <SelectTrigger className="w-[80px] text-charcoal">
                    <SelectValue placeholder="Country" />
                  </SelectTrigger>
                  <SelectContent>
                    <SelectItem value="CA">
                      <img
                        src={canadaFlag}
                        alt="canada-flag"
                        width="32px"
                        height="32px"
                      />
                    </SelectItem>
                    <SelectItem value="US">
                      <img
                        src={americaFlag}
                        alt="usa-flag"
                        width="32px"
                        height="32px"
                      />
                    </SelectItem>
                  </SelectContent>
                </Select>
              </NavLink>

              {user ? (
                <>
                  <Button
                    onClick={logout}
                    className="font-medium !bg-primary h-[40px]"
                  >
                    Log out
                  </Button>
                </>
              ) : (
                <>
                  <Link to="/auth/login" className="!no-underline">
                    <Button
                      className="font-medium !bg-primary h-[40px]"
                      onClick={() => setIsMenuOpen((prev) => !prev)}
                    >
                      Sign In
                    </Button>
                  </Link>
                </>
              )}

              {/* <Link to="/auth" className="!no-underline">
                <Button className="font-medium bg-primary hover:bg-green-700 h-[40px]">
                  Sign In
                </Button>
              </Link> */}

              {/* <ScheduleDemo> */}
                  <Link to="/auth/signup" className="!no-underline">
              <Button className="w-[120px] md:w-[140px] h-[40px] md:h-10 rounded-md bg-primary hover:bg-green-700 text-xs md:text-sm font-medium text-white transition-colors"
                // onClick={() => {
                  
                // }}
                >
                Get Started
              </Button>
              </Link>
              {/* </ScheduleDemo> */}
            </div>
          </div>
        </div>
      )}
    </header>
  );
}
